import React from 'react';
import { Card } from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { formatDateTime } from '../../../../utils/functions';

const EnhancedAutoresponseSentCardView = ({
    record,
    onCardClick
}) => {
    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
            bodyStyle={{ padding: '16px', display: 'flex', flexDirection: 'column', height: '100%' }}
        >
            <div className="flex-1 space-y-4">
                <div className="flex items-center gap-2 text-primary font-medium">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                    <span className="text-sm font-semibold">
                        {formatDateTime(record.dateAsPerUserTimezone)}
                    </span>
                </div>

                <div className="bg-gray-50 p-3 rounded border border-gray-100 flex items-center justify-between">
                    <span className="text-gray-600 text-sm font-medium">Total Sent (Leads)</span>
                    <span className="text-lg font-bold text-gray-800">
                        {Array.isArray(record.leadSent) ? record.leadSent.length : 0}
                    </span>
                </div>

                <div className="text-xs text-gray-400">
                    <span className="font-semibold">Created At:</span> {formatDateTime(record.createdAt)}
                </div>
            </div>
        </Card>
    );
};

export default EnhancedAutoresponseSentCardView;
